"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function SeccionLegal() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const accordionItems = [{
    title: "Política de privacidad",
    content: <div className="space-y-6 text-foreground leading-relaxed">
          <p className="text-base">En Aerolimpio, nos comprometemos con proteger y respetar su privacidad. Esta Política de privacidad explica cómo recopilamos, usamos, almacenamos y protegemos su información personal cuando utiliza nuestros servicios o visita nuestro sitio web.</p>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">1. Recopilación de datos</h4>
            <p className="text-base">Recopilamos información personal que usted nos proporciona directamente, incluyendo pero no limitada a:</p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Nombre completo y datos de contacto (correo electrónico, número de teléfono, dirección)</li>
              <li>Información de la empresa o propiedad que requiere servicios de limpieza</li>
              <li>Detalles específicos sobre el proyecto o servicio solicitado</li>
              <li>Información de facturación y pago cuando contrata nuestros servicios</li>
              <li>Comunicaciones que mantiene con nosotros a través de cualquier canal</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              2. Uso de la Información
            </h4>
            <p className="text-base">
              Utilizamos la información recopilada para los siguientes propósitos:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Proporcionar y mejorar nuestros servicios de limpieza con drones</li>
              <li>Procesar solicitudes de diagnósticos gratuitos y cotizaciones</li>
              <li>Gestionar proyectos y coordinar servicios de limpieza</li>
              <li>Comunicarnos con usted sobre sus proyectos, servicios y actualizaciones</li>
              <li>Procesar pagos y mantener registros financieros</li>
              <li>Cumplir con obligaciones legales y regulatorias</li>
              <li>Mejorar nuestro sitio web y experiencia de usuario</li>
              <li>Enviar información promocional sobre nuestros servicios (con su consentimiento)</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              3. Protección de Datos
            </h4>
            <p className="text-base">
              Implementamos medidas de seguridad técnicas y organizativas apropiadas para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción. Estas medidas incluyen:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Cifrado de datos sensibles durante la transmisión y almacenamiento</li>
              <li>Controles de acceso restringido a información personal</li>
              <li>Auditorías de seguridad regulares</li>
              <li>Capacitación de personal en protección de datos</li>
              <li>Protocolos de respuesta a incidentes de seguridad</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              4. Compartir Información
            </h4>
            <p className="text-base">
              No vendemos, alquilamos ni compartimos su información personal con terceros para fines de marketing. Podemos compartir su información únicamente en las siguientes circunstancias:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Con proveedores de servicios que nos ayudan a operar nuestro negocio (procesadores de pago, servicios de alojamiento web)</li>
              <li>Cuando sea requerido por ley o para cumplir con procesos legales</li>
              <li>Para proteger nuestros derechos, propiedad o seguridad, o los de nuestros clientes</li>
              <li>Con su consentimiento explícito para fines específicos</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              5. Cookies y Tecnologías Similares
            </h4>
            <p className="text-base">
              Nuestro sitio web utiliza cookies y tecnologías similares para mejorar su experiencia de navegación, analizar el uso del sitio y personalizar contenido. Usted puede controlar el uso de cookies a través de la configuración de su navegador. Las cookies que utilizamos incluyen:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Cookies esenciales para el funcionamiento del sitio</li>
              <li>Cookies analíticas para comprender cómo los usuarios interactúan con nuestro sitio</li>
              <li>Cookies de preferencias para recordar sus configuraciones</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              6. Sus Derechos
            </h4>
            <p className="text-base">
              De acuerdo con la legislación colombiana de protección de datos, usted tiene los siguientes derechos:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Acceder a su información personal que mantenemos</li>
              <li>Solicitar la corrección de datos inexactos o incompletos</li>
              <li>Solicitar la eliminación de su información personal (sujeto a obligaciones legales)</li>
              <li>Oponerse al procesamiento de sus datos personales</li>
              <li>Solicitar la restricción del procesamiento de sus datos</li>
              <li>Retirar su consentimiento en cualquier momento</li>
              <li>Presentar una queja ante la autoridad de protección de datos</li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              7. Retención de Datos
            </h4>
            <p className="text-base">
              Conservamos su información personal solo durante el tiempo necesario para cumplir con los propósitos para los cuales fue recopilada, incluyendo el cumplimiento de obligaciones legales, contables o de reporte. Los períodos de retención varían según el tipo de información y el propósito de su uso.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              8. Transferencias Internacionales
            </h4>
            <p className="text-base">
              En algunos casos, su información puede ser transferida y procesada en países fuera de Colombia. Cuando esto ocurra, nos aseguramos de que existan salvaguardas adecuadas para proteger su información de acuerdo con esta Política de Privacidad y las leyes aplicables.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              9. Menores de Edad
            </h4>
            <p className="text-base">
              Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos intencionalmente información personal de menores. Si descubrimos que hemos recopilado inadvertidamente información de un menor, tomaremos medidas para eliminar dicha información.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              10. Cambios a esta Política
            </h4>
            <p className="text-base">
              Podemos actualizar esta Política de Privacidad periódicamente para reflejar cambios en nuestras prácticas o por razones legales u operativas. Le notificaremos sobre cualquier cambio significativo publicando la nueva política en nuestro sitio web con una fecha de "última actualización".
            </p>
          </div>
        </div>
  }, {
    title: "Contacto legal",
    content: <div className="space-y-4">
          <p className="text-base">
            Si tiene preguntas, inquietudes o solicitudes relacionadas con esta Política de Privacidad o el manejo de su información personal, puede contactarnos a través de:
          </p>
          <div className="pl-6 space-y-2 text-base">
            <p><strong>Aerolimpio</strong></p>
            <p>Correo electrónico: info@aerolimpio.com</p>
            <p>WhatsApp: +57 316 273 8270</p>
            <p>Sitio web: www.aerolimpio.com</p>
          </div>
          
        </div>
  }, {
    title: "Información de la empresa",
    content: <div className="space-y-4">
          <div className="text-base leading-relaxed text-secondary/80">
            <p className="font-semibold text-secondary">Aerolimpio SAS</p>
            
            <p>Bogotá, Colombia</p>
          </div>
        </div>
  }, {
    title: "Términos y condiciones",
    content: <div className="space-y-6">
          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              1. Objeto y Alcance
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Los presentes Términos y Condiciones regulan el uso del sitio web de Aqua Drone Col y los servicios ofrecidos a través del mismo. Al acceder y utilizar nuestro sitio web, usted acepta estar sujeto a estos términos en su totalidad. Si no está de acuerdo con alguna parte de estos términos, le recomendamos no utilizar nuestro sitio web ni nuestros servicios.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              2. Naturaleza de los Servicios
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Aqua Drone Col proporciona servicios de limpieza exterior mediante tecnología de drones avanzada. Nuestros servicios están dirigidos a edificios de gran altura, torres residenciales, instalaciones industriales, hoteles, obras en construcción y paneles solares. Todos los servicios están sujetos a disponibilidad, evaluación técnica previa y condiciones climáticas favorables para garantizar la seguridad y eficacia de la operación.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              3. Responsabilidad del Usuario
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              El usuario se compromete a proporcionar información veraz y actualizada al solicitar nuestros servicios. Es responsabilidad del cliente permitir el acceso necesario a las instalaciones y garantizar que no existan obstáculos que impidan la operación segura de los drones. Aqua Drone Col no se hace responsable de retrasos o imposibilidad de ejecución causados por información incorrecta o falta de acceso adecuado.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              4. Limitación de Responsabilidad
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Aqua Drone Col realiza inspecciones previas y cuenta con seguros operacionales para sus equipos. Sin embargo, no nos hacemos responsables de daños pre-existentes en las superficies a limpiar ni de situaciones causadas por factores externos fuera de nuestro control (condiciones climáticas extremas, interferencias técnicas, etc.). Nuestro servicio se limita exclusivamente a la limpieza exterior según lo acordado en cada contrato.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              5. Propiedad Intelectual
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Todos los contenidos de este sitio web, incluyendo textos, imágenes, gráficos, logotipos, videos y diseño, son propiedad exclusiva de Aqua Drone Col y están protegidos por las leyes de propiedad intelectual vigentes en Colombia. Queda prohibida la reproducción, distribución o modificación de cualquier contenido sin autorización previa por escrito.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              6. Enlaces Externos
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Nuestro sitio web puede contener enlaces a sitios de terceros con fines informativos. Aqua Drone Col no se responsabiliza por el contenido, políticas de privacidad o prácticas de dichos sitios externos. El acceso a estos enlaces es bajo responsabilidad del usuario.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              7. Protección de Datos
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Aqua Drone Col se compromete a proteger la privacidad de sus usuarios conforme a la legislación colombiana vigente (Ley 1581 de 2012 y sus decretos reglamentarios). Los datos personales proporcionados por el usuario serán tratados de forma confidencial y utilizados únicamente para los fines relacionados con la prestación de nuestros servicios. Para más información, consulte nuestra Política de Privacidad.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              8. Modificaciones
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Aqua Drone Col se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento sin previo aviso. Las modificaciones entrarán en vigor desde su publicación en el sitio web. Es responsabilidad del usuario revisar periódicamente estos términos para estar al tanto de cualquier cambio.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              9. Contacto
            </h4>
            <p className="text-base leading-relaxed text-secondary/80">
              Para cualquier consulta o aclaración sobre estos Términos y Condiciones, puede ponerse en contacto con nosotros a través de los canales indicados en nuestra página de Contacto. Estaremos encantados de atenderle y resolver cualquier duda que pueda tener.
            </p>
          </div>
        </div>
  }, {
    title: "Política de cookies",
    content: <div className="space-y-6">
          <p className="text-base font-bold text-secondary">
            POLÍTICA DE COOKIES — AQUA DRONE COL
          </p>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              1. ¿Qué son las cookies?
            </h4>
            <p className="text-base">
              Las cookies son pequeños archivos que se almacenan en el dispositivo del usuario cuando navega por sitios web. Sirven para mejorar la experiencia de navegación, analizar el uso del sitio y recordar preferencias.
            </p>
            <p className="text-base">
              Las cookies no almacenan información personal sensible como nombres, teléfonos o direcciones.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              2. ¿Qué tipos de cookies utilizamos?
            </h4>
            
            <div className="space-y-4 pl-4">
              <div>
                <p className="text-base font-semibold text-secondary mb-2">
                  a. Cookies técnicas (necesarias)
                </p>
                <p className="text-base">
                  Permiten que el sitio funcione correctamente. Ejemplos: carga de páginas, seguridad básica, navegación interna.
                </p>
                <p className="text-base">
                  Estas cookies siempre están activas.
                </p>
              </div>

              <div>
                <p className="text-base font-semibold text-secondary mb-2">
                  b. Cookies de análisis
                </p>
                <p className="text-base">
                  Nos ayudan a entender cómo los usuarios interactúan con el sitio: páginas más visitadas, tiempo de navegación, clics, etc. Se utilizan herramientas como Google Analytics u otros servicios similares.
                </p>
                <p className="text-base">
                  Nos permiten mejorar la experiencia y optimizar el contenido.
                </p>
              </div>

              <div>
                <p className="text-base font-semibold text-secondary mb-2">
                  c. Cookies de preferencias
                </p>
                <p className="text-base">
                  Recuerdan ciertas configuraciones elegidas por el usuario, como idioma o región.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              3. ¿Cómo puede el usuario controlar las cookies?
            </h4>
            <p className="text-base">
              El usuario puede:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Aceptar o rechazar el uso de cookies no esenciales.</li>
              <li>Configurar su navegador para bloquear o eliminar cookies.</li>
            </ul>
            <p className="text-base mt-4">
              Los principales navegadores permiten gestionar cookies:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>Google Chrome</li>
              <li>Safari</li>
              <li>Firefox</li>
              <li>Edge</li>
            </ul>
            <p className="text-base mt-4 font-semibold">
              Advertencia: desactivar cookies puede afectar la funcionalidad del sitio.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              4. Cookies de terceros
            </h4>
            <p className="text-base">
              Algunas cookies pueden ser instaladas por servicios externos integrados en nuestro sitio, como:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-base">
              <li>APIs de redes sociales</li>
              <li>Google services</li>
              <li>Herramientas de análisis</li>
            </ul>
            <p className="text-base mt-4">
              Aqua Drone Col no controla directamente estas cookies, pero sólo utiliza proveedores confiables.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              5. Cambios en esta Política de Cookies
            </h4>
            <p className="text-base">
              Podemos actualizar esta política en cualquier momento para reflejar cambios en la tecnología o en los servicios ofrecidos.
            </p>
            <p className="text-base">
              La versión vigente será la publicada en esta sección.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-xl font-bold text-secondary">
              6. Contacto
            </h4>
            <p className="text-base">
              Si tiene dudas sobre esta Política de Cookies, puede escribirnos a:
            </p>
            <div className="pl-6 space-y-2 text-base">
              <p><strong>info@aerolimpio.com</strong></p>
            </div>
          </div>
        </div>
  }];
  return <section className="bg-white py-20 md:py-32">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={headerRef} className={`text-center mb-12 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-secondary">Sección legal</h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-6 rounded-full" />
        </div>

        <div className="space-y-3">
          {accordionItems.map((item, i) => <div key={i} data-index={i} className="border border-secondary/10 rounded-lg overflow-hidden transition-all duration-[var(--duration-medium)]">
              <Button onClick={() => toggleAccordion(i)} className="w-full flex items-center justify-between p-6 bg-white hover:bg-secondary/5 text-left transition-colors duration-[var(--duration-fast)] border-0 rounded-none" variant="ghost">
                <h3 className="text-xl md:text-2xl font-bold text-secondary">
                  {item.title}
                </h3>
                <ChevronDown className={`w-5 h-5 text-primary transition-transform duration-[var(--duration-medium)] ${openIndex === i ? "rotate-180" : ""}`} />
              </Button>
              
              <div className={`overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${openIndex === i ? "max-h-[5000px] opacity-100" : "max-h-0 opacity-0"}`}>
                <div className="px-6 pb-6 pt-2 border-t border-secondary/10">
                  {item.content}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 flex justify-center">
          <div className="w-32 h-0.5 bg-primary/30 rounded-full" />
        </div>
      </div>
    </section>;
}